import * as Yup from 'yup';
import { yupToFormErrors } from 'formik';

const OutpatientValidationSchema = Yup.object().shape({
    companyId: Yup.string()
        .required('Company is required.'),
    benefitGroup: Yup.string()
        .required('Type Of Benefit is required.'),
    benefitGroupItem: Yup.string()
        .required('Benefit Option is required.'),
    showDiagnosis: Yup.boolean()
        .required(),
    claimantId: Yup.string()
        .required('Claimant is required.'),
    receiptNo: Yup.string()
    .required('Receipt Number is required.'),
    visitDate: Yup.date()
        .required('Visit Date is required.'),
    // diagnosisCode: Yup.string()
    //     .when('prePostHospitalisation', {
    //         is: 'N',
    //         then: Yup.string().required('Diagnosis is required.'),
    //         otherwise: Yup.string()
    //     }),
    diagnosisText: Yup.string().when('showDiagnosis', {
            is: true,
            then: Yup.string().required('Diagnosis is required.'),
            otherwise: Yup.string(),
          }),
    providerName: Yup.string()
        .required('Name Of Provider is required.'),
    amount: Yup.number()
        .required('Amount is required')
        .positive('Amount must be more than zero')
        .max(999999, 'Amount cannot be more than $999,999')
        .round(),
    currency: Yup.string()
        .required('Currency is required.'),
    remarks: Yup.string().lowercase(),
    prePostHospitalisation: Yup.string().required().uppercase().oneOf(['Y','N']),
    includeGST: Yup.string().required().uppercase().oneOf(['Y','N']),
});

export default OutpatientValidationSchema;